export let passwordValue = "";

export const setPasswordValue = (s: string) => {
    passwordValue = s;
}

export const getPasswordValue = () => {
    return passwordValue;
}